// TODO This will animation will be bugged if the target collapsing element has padding.

import { Dictionary } from '../../../utils';

export type SizeProperty = 'height' | 'width';

export class AnimateSizeToAuto {

  constructor(private readonly sizeProperty: SizeProperty = 'height') {}

  private size: number;

  beforeEnter = ((el: HTMLElement) => {
    el.style[this.sizeProperty] = '0';
    this.collapseMargin(el);
    el.getBoundingClientRect(); // This is intended. We want to provoke a layer repaint to apply this style.
  });

  enter = ((el: HTMLElement) => {
    this.getSize(el);
    el.style[this.sizeProperty] = `${ this.size }px`;
    this.clearMargin(el);
  });

  afterEnter = ((el: HTMLElement) => {
    el.style.removeProperty(this.sizeProperty);
  });

  beforeLeave = ((el: HTMLElement) => {
    this.getSize(el);
    el.style[this.sizeProperty] = `${ this.size }px`;
    el.getBoundingClientRect(); // This is intended. We want to provoke a layer repaint to apply this style.
  });

  leave = ((el: HTMLElement) => {
    el.style[this.sizeProperty] = '0';
    this.collapseMargin(el);
  });

  afterLeave = ((el: HTMLElement) => {
    el.style.removeProperty(this.sizeProperty);
    this.clearMargin(el);
  });

  animationsHooks: Dictionary<Function> = {
    beforeEnter: this.beforeEnter,
    enter: this.enter,
    afterEnter: this.afterEnter,
    beforeLeave: this.beforeLeave,
    leave: this.leave,
    afterLeave: this.afterLeave
  };

  private getSize(el: HTMLElement) {
    this.size = this.sizeProperty === 'height' ? el.scrollHeight : el.scrollWidth;
  }

  private collapseMargin(el: HTMLElement) {
    const margin = this.sizeProperty === 'height' ?
      { marginTop: '0', marginBottom: '0' } :
      { marginLeft: '0', marginRight: '0' };
    Object.assign(el.style, margin);
  }

  private clearMargin(el: HTMLElement) {
    if (this.sizeProperty === 'height') {
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
    } else {
      el.style.removeProperty('margin-left');
      el.style.removeProperty('margin-right');
    }
  }
}
